import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { MISC, API } from '@const'
import * as utils from '@utils'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, MenuItem } from '@material-ui/core'
import { TextField } from '@prototype'
import { withStyles } from '@material-ui/styles'
import { green } from '@material-ui/core/colors'

class RedPacket extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'RedPacket', options)
        }
        this.state = {
            dialogOpen: false,
            type: '',
            eventID: 0,
            amount: '',
            amountList: [],
            isSend: false,
            account: '',
            accountList: MISC.EVENT_FAKEACCOUNT_LIST,
            valid: false,
            continue: false,
            isLoading: true,
            isMounted: false,
            addList: [],
            data: [],
            bonus: ''
        }
    }

    componentDidMount() {
        const { eventID, type, detail } = this.props.options
        const init = {
            eventID,
            type,
            account: this.state.accountList[0]
        }
        /** 已無編輯需求, 功能預留 */
        if (type === 'edit') {
            init.account = detail.account
            init.amount = detail.amount
        }
        this.setState({
            ...init,
            dialogOpen: true,
            isLoading: false,
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
        this.props.closeDialog()
    }

    handleSubmit(callbackType) {
        this.setState({
            valid: true,
            isLoading: true,
            continue: callbackType === 'continue'
        })
        utils.apiRequest(
            'post',
            API.FAKEACCOUNT_RED_PACKET,
            {
                "event_id": this.state.eventID,
                "account_prefix": this.state.account,
                "bonus": Number(this.state.bonus)
            },
            (data) => {
                if (this.state.type === 'add') {
                    this.setState({
                        addList: [data],
                        isLoading: false,
                        isSend: true
                    })
                } else {
                    this.handleConfirm()
                }
            },
            (_err) => {
                this.setState({
                    isLoading: false
                })
            }
        )
    }

    handleConfirm() {
        this.props.queryData()
        if (this.state.continue === false) {
            this.closeDialog()
        } else {
            this.setState({
                isSend: false,
                isMounted: false,
                isLoading: true,
                valid: false,
                continue: false
            }, () => {
                this.setState({
                    isMounted: true,
                    isLoading: false,
                })
            })
        }
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} fullWidth maxWidth="xs" disableEscapeKeyDown={true}>
                <DialogTitle>{this.state.isSend ? this.t('view') : this.state.type === 'add' ? this.t('add') : this.t('edit')}</DialogTitle>
                <DialogContent className={this.props.classes.content}>
                    {!this.state.isSend &&
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.formControl}
                                        select
                                        label={this.state.type === 'add' ? this.t('fakeAccountPrefix') : this.t('fakeAccount')}
                                        value={this.state.account}
                                        onChange={(event) =>
                                            this.setState({
                                                account: event.target.value,
                                            })
                                        }
                                        disabled={this.state.type === 'edit'}
                                    >
                                        {this.state.accountList.map(item => (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                {(() => {
                                    return (
                                        <Grid item xs={12}>
                                            <TextField
                                                placeholder={this.t('pleaseEnter', { params: utils.t('doppelganger', 'EventManagementPage') })}
                                                value={this.state.bonus}
                                                onChange={(event) => {
                                                    const value = event.target.value
                                                    
                                                    this.setState({
                                                        bonus: value.replace(/[^0-9]/g, '')
                                                    })
                                                }}
                                                className={this.props.classes.formControl}
                                                style={{
                                                    width: '300px'
                                                }}
                                            >
                                            </TextField>
                                        </Grid>
                                    )
                                })()}
                            </Grid>
                        </Grid>
                    }
                    {this.state.isSend &&
                        <Grid container spacing={2}>
                            <Grid item xs={12} className={this.props.classes.addListHeader}>
                                {this.t('accountBeenAdd', { value: this.state.addList.length })}
                            </Grid>
                            <Grid item xs={12} className={this.props.classes.addListContent}>
                                {this.state.addList.map(account => (
                                    <span key={account}>
                                        {account}
                                    </span>
                                ))}
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    {(this.state.type === 'add' && !this.state.isSend) &&
                        <>
                            <Button variant="contained" onClick={() => this.closeDialog()} color="secondary" disabled={this.state.isLoading}>
                                {this.t('cancel')}
                            </Button>
                            <Button variant="contained" onClick={() => this.handleSubmit()} color="primary" disabled={this.state.isLoading}>
                                {this.t('closeAfterAdd')}
                            </Button>
                            <GreenButton variant="contained" onClick={() => this.handleSubmit('continue')} color="primary" disabled={this.state.isLoading}>
                                {this.t('continueAfterAdd')}
                            </GreenButton>
                        </>
                    }
                    {this.state.isSend &&
                        <Button variant="contained" onClick={() => this.handleConfirm()} color="primary">
                            {this.t('confirm')}
                        </Button>
                    }
                    {this.state.type === 'edit' &&
                        <Button variant="contained" onClick={() => this.handleSubmit()} color="primary">
                            {this.t('save')}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '200px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '200px',
        },
        adornment: {
            display: 'inline-flex',
            height: 'auto',
            whiteSpace: 'nowrap',
            marginRight: 20,
            '& p': {
                fontSize: 12
            }
        },
        addListHeader: {
            textAlign: 'center',
            fontSize: 15,
            color: '#69131c'
        },
        addListContent: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            '& span': {
                width: '100%',
                textAlign: 'center'
            }
        },
        content: {
            position: 'relative'
        },
        loadingIcon: {
            marginRight: 8,
            color: '#666'
        }
    }
}

const GreenButton = withStyles(() => ({
    root: {
        color: '#ffffff',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
}))(Button);

RedPacket.propTypes = {
    classes: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
    options: PropTypes.object,
    queryData: PropTypes.func,
}

export default hoc(styles)(RedPacket)
